import * as React from "react";

import { useState, useEffect } from "react";

import { useCtx } from 'one-ui-provider';

import Table from "antd/lib/table";

import Modal from "antd/lib/modal";


import Row from "antd/lib/row";

import Col from "antd/lib/col";

import Select from "antd/lib/select";

import Typography from "antd/lib/typography";

import DatePicker  from "antd/lib/date-picker";

import Input from "antd/lib/input";

import Radio from "antd/lib/radio";

import Form from "antd/lib/form";

import Divider from 'antd/lib/divider';

import Tooltip from 'antd/lib/tooltip';

import Button from 'antd/lib/button';

import { Prescription } from "one-state-prescription";

import {
  TableLight
} from 'one-ui-table';

import { PrescriptionModel } from "./model";

import { PrescriptionCardProps } from "./props";

import { checkCardHasError, TabErrorMsg } from "one-card-notification";

import { useDispatch, useSelector } from "react-redux";

import moment from 'moment';


import notification from "antd/lib/notification";

const { Option } = Select;

const { Text } = Typography;

const { TextArea } = Input;

/** 

 * This function returns the Referral Tab 

 * @param props is a component property 

 * @returns JSX code for Referral Tab Card 

 */

export const PrescriptionTab = <M extends PrescriptionModel>(
  props: PrescriptionCardProps<M>
) => {
  const { model, onRefillScreenpopChange } = props;

  const { prescriptiondata } = model || {};

  const { settings} = useCtx();

  let { uisettings: {deacodenumber, refill_display } }= settings;

  let tabledata: any = [];

  tabledata = prescriptiondata.prescriptiondata || [];

  let appdata: Prescription = {};

  let prescriptionUIBody;

  let deliverytypeui = <div></div>;

  let fillstextui = <div></div>;



  const [datamodel, setDatamodel] = useState(false);

  const [selecteddetails, setSelecteddetails] = useState(appdata);

  const [charactercount, setCharacterCount] = useState(0);

  const [appcomments, setAppcomments] = useState("");

  const [selecteddate, setSelectedDate] = useState("");

  const [streetText, setStreetText] = useState("");

  const [cityText, setCityText] = useState("");

  const [stateText, setStateText] = useState("");

  const [pincodeText, setPinCodeText] = useState("");

  const [radioOptions, setRadioOptions] = useState([]);

  const [radiostate, setRadioState] = useState('');

  const [addressRadio, setAddressRadio] = useState('');

  const [modaldetails,setModalDetails] = useState({});

  const refilldata = useSelector((state: any) => state.presrefill);
  
  let ehrProvider = sessionStorage.getItem('ehr');

  const [selectedValue, setSelectedValue] = useState('');
  const [showRadio, setShowRadio] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showInput, setShowInput] = useState(false);
  const [inputDisable, setInputDisable] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (refilldata) {

      notification.config({
        placement: "topRight",

        top: 300,

        duration: 10,
      });

      if (refilldata.success === true) {
        notification["success"]({
          message: "Refill requested successfully",

          description: "",
        });
        setDatamodel(false);
      }
      else if(refilldata?.error?.type === "error") {
        if(refilldata?.error?.erroritems?.length > 0) {
          refilldata.error.erroritems.forEach((errorinfo:any)=>{
            notification["error"]({
              message:errorinfo.display_text,
              description: "",
            });
            setDatamodel(true);
          })
        }
      }
    }
  }, [refilldata]);

  const handleCancel = (e: any) => {
    setDatamodel(false);
    setCharacterCount(0);
    setCityText('')
    setStateText('')
    setStreetText('')
    setPinCodeText('')
    setAppcomments('')
  };

  const disabledDate = (current: any) => {
    // Can not select days before today
  return current && moment().add(-1, 'days')  >= current;
  };
  const handleRefill = (e: any) => {
    if (selecteddetails?.ispartialfillremain === "true") {
      notification.config({
        placement: "topRight",

        top: 300,

        duration: 10,
      });

      notification["error"]({
        message:  "Refills are Partially Fillable. Patient can reach out to Pharmacy Staff or Agent can make a request in the Epic Hyperspace",

        description:"",
      });
    } else if (selecteddetails?.hasfillinprogress === "true") {
      notification.config({
        placement: "topRight",

        top: 300,

        duration: 10,
      });

      notification["error"]({
        message:"Unable to make a refill request as Fills are in progress",

        description: "",
      });
    } else if (selecteddetails?.isfillable === "false") {
      notification.config({
        placement: "topRight",

        top: 300,

        duration: 10,
      });

      notification["error"]({
        message: "Unable to make Refill request",

        description: "",
      });
    } else if (deacodenumber.includes(selecteddetails?.deacodenumber) ) {
      notification.config({
        placement: "topRight",

        top: 300,

        duration: 10,
      });

      notification["error"]({
        message: "Unable to refill Prescription as its a Class 1 or 2 drug",

        description: "",
      });
    } else {
      let deliveryaddress = "";
      if(selectedValue === "") {
        dispatch({
          type: "one-state-prescriptionrefills/fetch",
  
          payload: {
            prescriptionId: selecteddetails?.prescriptionid,
            pickupDateTime: selecteddate ? selecteddate : "",
            pickupPharmacyNCPDPId: selecteddetails?.pickuppharmacyid,
            deliveryComments: deliveryaddress ? deliveryaddress : "",
            comments: appcomments ? appcomments : "",
            deliveryMethod: selectedValue ? selectedValue : "",
            deliveryDestination: addressRadio ? addressRadio  : ""
          },
        });
      }
      else if(selectedValue === "Pickup") {
        if(radiostate === "Earliest Available" || radiostate === "") {
          dispatch({
            type: "one-state-prescriptionrefills/fetch",
    
            payload: {
              prescriptionId: selecteddetails?.prescriptionid,
              pickupDateTime: selecteddate ? selecteddate : "",
              pickupPharmacyNCPDPId: selecteddetails?.pickuppharmacyid,
              deliveryComments: deliveryaddress ? deliveryaddress : "",
              comments: appcomments ? appcomments : "",
              deliveryMethod: selectedValue ? selectedValue : "",
              deliveryDestination: addressRadio ? addressRadio  : ""
            },
          });
        }
        else if(radiostate === "Select Date/Time" && Object.keys(selecteddate).length > 0) {
          dispatch({
            type: "one-state-prescriptionrefills/fetch",
    
            payload: {
              prescriptionId: selecteddetails?.prescriptionid,
              pickupDateTime: selecteddate ? selecteddate : "",
              pickupPharmacyNCPDPId: selecteddetails?.pickuppharmacyid,
              deliveryComments: deliveryaddress ? deliveryaddress : "",
              comments: appcomments ? appcomments : "",
              deliveryMethod: selectedValue ? selectedValue : "",
              deliveryDestination: addressRadio ? addressRadio  : ""
            },
          });
        } 
      }
      else if(selectedValue === "Mail") {
        if(radiostate === "Default Address") {
          dispatch({
            type: "one-state-prescriptionrefills/fetch",
    
            payload: {
              prescriptionId: selecteddetails?.prescriptionid,
              pickupPharmacyNCPDPId: selecteddetails?.pickuppharmacyid,
              deliveryComments: deliveryaddress ? deliveryaddress : "",
              comments: appcomments ? appcomments : "",
              deliveryMethod: selectedValue ? selectedValue : "",
              deliveryDestination: addressRadio ? addressRadio  : ""
            },
          });
        }
        else if(radiostate === "New Address") {
          if(Object.keys(streetText).length === 0) {
            notification.config({
              placement: "topRight",
      
              top: 300,
      
              duration: 10,
            });
      
            notification["error"]({
              message: "Please enter the StreetName (Ex:2987 Lake Way)",
      
              description: "",
            });
          }
          else if(Object.keys(cityText).length === 0) {
            notification.config({
              placement: "topRight",
      
              top: 300,
      
              duration: 10,
            });
      
            notification["error"]({
              message: "Please enter the City (Ex:MELVINDALE)",
      
              description: "",
            });
          }
          else if(Object.keys(stateText).length === 0) {
            notification.config({
              placement: "topRight",
      
              top: 300,
      
              duration: 10,
            });
      
            notification["error"]({
              message: "Please enter the State (Ex:Michigan)",
      
              description: "",
            });
          }
    
          else if(Object.keys(pincodeText).length === 0) {
            notification.config({
              placement: "topRight",
      
              top: 300,
      
              duration: 10,
            });
      
            notification["error"]({
              message: "Please enter the Postal Code (Ex:48122)",
      
              description: "",
            });
          }
    
          if((Object.keys(streetText).length > 0) && (Object.keys(cityText).length > 0) && (Object.keys(stateText).length > 0) && (Object.keys(pincodeText).length > 0)) {
            deliveryaddress = streetText + "," + cityText + "," + stateText + "," + pincodeText;
          }
          if(Object.keys(deliveryaddress).length === 0) {
            //do nothing
          }
          else {
            dispatch({
              type: "one-state-prescriptionrefills/fetch",
      
              payload: {
                prescriptionId: selecteddetails?.prescriptionid,
                pickupPharmacyNCPDPId: selecteddetails?.pickuppharmacyid,
                deliveryComments: deliveryaddress ? deliveryaddress : "",
                comments: appcomments ? appcomments : "",
                deliveryMethod: selectedValue ? selectedValue : "",
                deliveryDestination: addressRadio ? addressRadio  : ""
              },
            });
    
          }
        }
      }
    }
  };

  const handleAppcomments = (event: any) => {
    //To  track the Character Count

    if (event.target.value.length <= 450) {
      setAppcomments(event.target.value);

      setCharacterCount(event.target.value.length);
    }
  };

  const handleRefillScreenPopClick = (e: any) => {
    if (onRefillScreenpopChange) {
      onRefillScreenpopChange(e);
    }
}

  const handleSelectChange = (value:any) => {
    setSelectedValue(value);
    // set radioOptions based on selected option
    switch(value) {
      case 'Pickup':{
        setRadioOptions(['Earliest Available', 'Select Date/Time']);
        if(radiostate === "Select Date/Time") {
          setShowDatePicker(true)
        }
        setShowInput(false)
      }
        break;
      case 'Mail':
        setRadioOptions(['Default Address', 'New Address']);
        {
          setShowDatePicker(false)
          if(radiostate === "Default Address") {
            setStreetText(selecteddetails.streetvalue)
            setCityText(selecteddetails.cityvalue);
            setStateText(selecteddetails.statevalue);
            setPinCodeText(selecteddetails.pincodevalue);
            setShowInput(true)
            setInputDisable(true)
            setAddressRadio("0")
          }
          else if(radiostate === "New Address") {
            setShowInput(true)
            setInputDisable(false)
            setAddressRadio("1")
            setCityText('')
            setStateText('')
            setStreetText('')
            setPinCodeText('')
          }
        }
        break;
      default:
        setRadioOptions([]);
        break;
    }
    setShowRadio(true); // set showRadio to true when an option is selected
  }

  const handleRadioChange = (e:any) => {
    setRadioState(e.target.value)
    if(e.target.value === "Earliest Available") {
      setShowDatePicker(false);
    }
    else if(e.target.value === "Select Date/Time") {
      setShowDatePicker(true); 
    }
    else if(e.target.value === "Default Address") {
      setStreetText(selecteddetails.streetvalue)
      setCityText(selecteddetails.cityvalue);
      setStateText(selecteddetails.statevalue);
      setPinCodeText(selecteddetails.pincodevalue);
      setShowInput(true)
      setInputDisable(true)
      setAddressRadio("0")
    }
    else if (e.target.value === "New Address") {
      setShowInput(true)
      setInputDisable(false)
      setAddressRadio("1")
      setCityText('')
      setStateText('')
      setStreetText('')
      setPinCodeText('')
    } 
  }


  const handleDateChange = (date:any, dateString:any) => {
    setSelectedDate(dateString)
  }

  const showModal = (event: any) => {
    setModalDetails(event)
    if (event?.ispartialfillremain === "true" || 
    event?.hasfillinprogress === "true" ||
    event?.isfillable === "false" ||
    deacodenumber.includes(event?.deacodenumber)) {
          //do nothing
    }
    else {
      setDatamodel(true);
    }
  };

  const columns = [
    {
      title: "Medication",

      dataIndex: "medication",

      key: "medication",
    },

    {
      title: "Authorizing Provider",

      key: "authorizingprovider",

      dataIndex: "authorizingprovider",
    },

    {
      title: "Start Date",

      key: "startdate",

      dataIndex: "startdate",
    },

    {
      title: "Refills Available",

      key: "fillsremaining",

      dataIndex: "fillsremaining",

      render: (data: any, record: any) => {
        let fillui;
        if (!(refill_display)) {
          fillui = <>{record.fillsremaining}</>;
        } else {
          let refillhandletext;
          if (record?.ispartialfillremain === "true") {
            refillhandletext = "You cannot refill this prescription because it is Partially Fillable. Please contact the Pharmacy staff to refill this prescription";
      
          } else if (record?.hasfillinprogress === "true") {
            refillhandletext = "You cannot refill this prescription because the fill is in progress";
          } else if (record?.isfillable === "false") {

            refillhandletext = "You cannot refill this prescription because this prescription is not fillable";

          } else if (deacodenumber.includes(record?.deacodenumber) ) {

            refillhandletext = "Unable to refill Prescription as its a Class 1 or 2 drug";
          } 
          else {
            refillhandletext = ""
          }
          setSelecteddetails(record);
          fillui = (
            <>
              <span>
                <a onClick={() => showModal(record)} color="#1890f">
                <Tooltip placement="top" title = {refillhandletext}>
                {record.fillsremaining}
                </Tooltip>
                </a>
              </span>
            </>
          );
        }

        return <div>{fillui}</div>;
      },
    },

    {
      title: "Prescription Status",

      key: "prescriptionstatus",

      dataIndex: "prescriptionstatus",
    },
  ];
  // To Check for the Error from the API

  if (checkCardHasError("Prescription") && tabledata.length === 0  ||( ehrProvider==='cerner')) {
    prescriptionUIBody = (
      <>
        <TabErrorMsg />
      </>
    );
  } else {
    prescriptionUIBody = (
      <>
        <Table columns={columns} dataSource={tabledata} />
      </>
    );
  }


  if (Object.keys(selecteddetails).length > 0) {
    if(selecteddetails?.enddate) {
      fillstextui = (
        <>
        <Col span={12}>
            <div className={"description-info"}>
              <div className="description-info__item">
                <b>{"Remaining Refills"}</b> {selecteddetails?.fillsremaining} <b style={{color: "#FF0000"}}>{"before"}</b> {selecteddetails?.enddate}
              </div>
            </div>
        </Col>
        </>
      )
    }
    else {
      fillstextui = (
        <>
        <Col span={12}>
            <div className={"description-info"}>
              <div className="description-info__item">
                <b>{"Remaining Refills"}</b> {selecteddetails?.fillsremaining}
              </div>
            </div>
        </Col>
        </>
      )
    }

    deliverytypeui = (
      <>
        <Row>
          <Col>
            <Text>Delivery Type: </Text>
            <>
              <Select
                size="small"
                onChange={handleSelectChange}
                value={selectedValue}
                defaultValue={"Select Delivery Type"}
                style={{ width: 129, marginTop: "9px" }}
              >
                {selecteddetails &&
                  selecteddetails.deliverytype &&
                  selecteddetails.deliverytype.map(
                    (pickuptype: any, index: number) => (
                      <Option value={pickuptype} key={index}>
                        {pickuptype}
                      </Option>
                    )
                  )}
              </Select>
            </>
          </Col>
        </Row>
        <Row>
          <Col>
            {showRadio &&
              radioOptions.length > 0 && ( // display radio buttons only when radioOptions is not empty
                <Radio.Group
                  onChange={handleRadioChange}
                  value={radiostate}
                  style={{ marginTop: "12px" }}
                >
                  {radioOptions.map((option) => (
                    <Radio value={option}>
                      {option}
                    </Radio>
                  ))}
                </Radio.Group>
              )}
          </Col>
        </Row>
        <Row>
          <Col>
            {showDatePicker && ( // display the datepicker only when showDatePicker is true
              <DatePicker
                showTime
                disabledDate={disabledDate}
                onChange={handleDateChange}
                style={{ marginTop: "12px" }}
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col>
            {showInput && ( 
              <Form
                className="ant-advanced-search-form"
                layout="vertical"
              >
              <div className="global-search-item-container">
                <div className="global-search-item">
                  <text>Street:</text>
                  <Form.Item className={"formantd"} >
                    {(
                      <Input
                        autoComplete="new-password"
                        placeholder="Street"
                        value={streetText}
                        size="small"
                        disabled = {inputDisable}
                        onChange={event => {
                        setStreetText(event.target.value)
                        }}
                      />
                    )}
                  </Form.Item>
                </div>
                <div className="global-search-item">
                  <text>City:</text>
                  <Form.Item className={"formantd"} style={{ fontSize: "12px" }}>
                    {(
                      <Input
                      autoComplete="new-password"
                        placeholder="City"
                        size="small"
                        value={cityText}
                        disabled = {inputDisable}
                        onChange={event => {
                          setCityText(event.target.value)
                        }}
                      />
                    )}
                  </Form.Item>
                </div>
                <div className="global-search-item">
                  <text>State:</text>
                  <Form.Item className={"formantd"}>
                    {(
                      <Input
                        autoComplete="new-password"
                        placeholder="State"
                        size="small"
                        value={stateText}
                        disabled = {inputDisable}
                        onChange={event => {
                          setStateText(event.target.value)
                        }}
                      />

                    )}
                  </Form.Item>
                </div>
                <div className="global-search-item">
                  <text>Postal Code:</text>
                  <Form.Item className={"formantd"} style={{fontSize:"10px"}}>
                    {(
                      <Input
                      autoComplete="new-password"
                      placeholder="Postal Code"
                      size="small"
                      value={pincodeText}
                      maxLength={5}
                      disabled = {inputDisable}
                      onChange={event => {
                        const re = /^[0-9\b]+$/;
                        if (event.target.value === '' || re.test(event.target.value)) {
                          setPinCodeText(event.target.value)
                        }

            
                      }}
                    />
                    )}
                  </Form.Item>
                </div>
              </div>
            </Form>)}
          </Col>
        </Row>
      </>
    );
  }

  return (
    <div>
      <TableLight title={""} body={prescriptionUIBody}
      screnpopepicbutton={<Button style={{backgroundColor:"#e84a13",color:"#fff"}} onClick={()=>handleRefillScreenPopClick(selecteddetails)}>Open Refill Encounter In Epic</Button>} />

      <Modal
        title="Prescription Refill"
        visible={datamodel}
        onOk={handleRefill}
        onCancel={handleCancel}
        closable={true}
        width={684}
        okText="Request"
      >
        <Row type="flex" gutter={[24, 24]}>
          <Col span={12}>
            <div className={"description-info"}>
              <div className="description-info__item">
                <b>{"Medication"}:</b> {modaldetails?.medication}
              </div>
            </div>
          </Col>
        </Row>
        <Row type="flex" gutter={[24, 24]}>
          <Col span={16}>
            <div className={"description-info"}>
              <div className="description-info__item">
                <b>{"Sig"}:</b> {modaldetails?.patientsig}
              </div>
            </div>
          </Col>
        </Row>
        <Row type="flex" gutter={[24, 24]}>
        {fillstextui}
        </Row>
        <Row type="flex" gutter={[24, 24]}>
          <Col span={16}>
            <div className={"description-info"}>
              <div className="description-info__item">
                <b>{"Last Refill Date"}:</b> {modaldetails?.lastrefilldate}
              </div>
            </div>
          </Col>
        </Row>
        <Row type="flex" gutter={[24, 24]}>
        <Col span={12}>
            <div className={"description-info"}>
              <div className="description-info__item">
                <b>{"Preferred Delivery Method"}:</b> {modaldetails?.deliverymethod}
              </div>
            </div>
          </Col>

          <Col span={12}>
            <div className={"description-info"}>
              <div className="description-info__item">
                <b>{"Last Refill Quantity"}:</b>{" "}
                {modaldetails?.lastrefillamount}
              </div>
            </div>
          </Col>
        </Row>
        <Row type="flex" gutter={[24, 24]}>
        <Col span={12}>
            <div className={"description-info"}>
              <div className="description-info__item">
                <b>{"Pickup Pharmacy Name"}:</b> {modaldetails?.pickuppharmacyname}
              </div>
            </div>
          </Col>
        </Row>
        <Divider/>
        {deliverytypeui}
        <Row>
          <Col>
            <div className={"description-info"} style={{marginTop: "10px"}}>
              <div className="description-info__item">
                <b>{"Comments"}:</b>
              </div>
            </div>

            <TextArea
              className="comment-text-area"
              rows={3}
              onChange={handleAppcomments}
              value={appcomments}
              maxLength={450}
            />

            <Text className="comment-box-text">Max 450 Characters</Text>

            <Text className="count-value">{charactercount}/450</Text>
          </Col>
        </Row>
      </Modal>
    </div>
  );
};
